import React from 'react';
import {
  TableCell,
  TableRow
} from '@material-ui/core';
import { format } from 'date-fns';
import { TextFormattedNumber } from 'components';
import { convertUTCDateToLocalDate } from 'helpers/date';


const formatDate = (date) => {
  return date
    ? (
      <>
        <div>{format(date, 'MM/dd/yyyy')}</div>
      </>
    )
    : null;
};

const CustomerTableRow = ({ customerData, headTableCells }) => {
  const {
    firstName,
    lastName,
    email,
    dob,
    phone,
    totalSpend,
    lastPayment,
    rewardPoints
  } = customerData;

  const columns = headTableCells.reduce((acc, column) => {
    acc[column.label] = column;

    return acc;
  }, {});

  const formattedDOB = dob ? convertUTCDateToLocalDate(dob) : '';
  const formattedLastPaymentDate = lastPayment ? convertUTCDateToLocalDate(lastPayment) : '';

  return (
    <TableRow>
      {columns['First Name']?.display && <TableCell>{firstName}</TableCell>}
      {columns['Last Name']?.display && <TableCell>{lastName}</TableCell>}
      {columns['Customer Email']?.display && <TableCell className="whitespace-no-wrap">{email}</TableCell>}
      {columns['Phone']?.display && <TableCell className="whitespace-no-wrap">{phone}</TableCell>}
      {columns['Reward Points']?.display && <TableCell>{rewardPoints}</TableCell>}
      {columns['Date of Birth']?.display &&
        <TableCell>
          {formatDate(formattedDOB)}
        </TableCell>
      }
      {columns['Last Purchase Date']?.display &&
        <TableCell>
          {formatDate(formattedLastPaymentDate)}
        </TableCell>
      }
      {columns['Total Spent']?.display &&
        <TableCell>
          <TextFormattedNumber
            value={totalSpend}
            prefix="$"
          />
        </TableCell>
      }
    </TableRow>
  );
};

export default CustomerTableRow;

